import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { DataAccessModulesService } from '@unico-people/shared/dashboard/data-access-modules';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as modulesActions from '../actions/modules.actions';

@Injectable()
export class ModulesEffects {
  constructor(private actions$: Actions, private modulesService: DataAccessModulesService) {}

  modules$ = createEffect(() =>
    this.actions$.pipe(
      ofType(modulesActions.LoadModules),
      mergeMap(res => {
        return this.modulesService.read(res.payload).pipe(
          map(module => modulesActions.LoadModulesSuccess({ payload: module })),
          catchError(err => of(modulesActions.LoadModulesFail({ payload: err })))
        );
      })
    )
  );
}
